// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 引入全局的样式
import "@/assets/styles/globalStyle.css";
// 引入全局的静态变量
import "@/assets/js/globalStatic.js";

Vue.config.productionTip = false;

Vue.use(Element, { size: "mini", zIndex: 3000 });

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js